function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "wqcua",
  d: "M406.36 2156.38c0 12.67-14.215 22.94-31.75 22.94s-31.75-10.27-31.75-22.94c0-12.67 14.215-22.94 31.75-22.94s31.75 10.27 31.75 22.94z"
}), React.createElement("path", {
  id: "wqcub",
  d: "M395.136 2172.85a4.96 4.96 0 0 1-4.583-3.07 4.976 4.976 0 0 1 1.078-5.416 4.953 4.953 0 0 1 5.408-1.073 4.97 4.97 0 0 1 3.057 4.596 4.965 4.965 0 0 1-4.96 4.962zm-33.59-3.065a4.976 4.976 0 0 1 1.074-5.419 4.953 4.953 0 0 1 5.408-1.076 4.97 4.97 0 0 1 3.059 4.597 4.965 4.965 0 0 1-4.953 4.962 4.96 4.96 0 0 1-4.588-3.064zm24.838-33.06h8.186a5.568 5.568 0 0 1 5.026 3.176l3.57 7.492h-16.782zm24.501 17.425c0-.31-.102-.612-.292-.858l-4.035-5.171-4.48-9.41a8.388 8.388 0 0 0-7.534-4.766h-8.16v-2.161c0-.77-.623-1.394-1.391-1.394h-29.746c-.768 0-1.391.624-1.391 1.394 0 .77.623 1.394 1.391 1.394h28.355v15.598c0 .77.623 1.394 1.391 1.394h19.652l3.478 4.454v11.897h-5.356a7.733 7.733 0 0 0-7.61-6.394 7.733 7.733 0 0 0-7.61 6.394h-13.803a7.733 7.733 0 0 0-7.61-6.394 7.733 7.733 0 0 0-7.61 6.394h-3.973c-.768 0-1.391.624-1.391 1.394 0 .77.623 1.394 1.391 1.394h3.986a7.74 7.74 0 0 0 7.604 6.324 7.74 7.74 0 0 0 7.603-6.324h13.788a7.74 7.74 0 0 0 7.604 6.324 7.74 7.74 0 0 0 7.603-6.324h5.364a2.785 2.785 0 0 0 2.782-2.788z"
}), React.createElement("path", {
  id: "wqcuc",
  d: "M361.025 2157.184c0-.77-.623-1.394-1.392-1.394h-7.652c-.768 0-1.391.624-1.391 1.394 0 .77.623 1.394 1.391 1.394h7.652c.769 0 1.392-.624 1.392-1.394z"
}), React.createElement("path", {
  id: "wqcud",
  d: "M348.501 2150.208h16c.769 0 1.392-.624 1.392-1.394 0-.77-.623-1.394-1.392-1.394h-16c-.768 0-1.391.624-1.391 1.394 0 .77.623 1.394 1.391 1.394z"
}), React.createElement("path", {
  id: "wqcue",
  d: "M350.59 2140.454c0 .77.623 1.394 1.391 1.394h16c.769 0 1.392-.624 1.392-1.394 0-.77-.623-1.394-1.392-1.394h-16c-.768 0-1.391.624-1.391 1.394z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  opacity: 0.7,
  transform: "rotate(165 342.21 1069.185)"
}, React.createElement("use", {
  fill: "#effff6",
  xlinkHref: "#wqcua"
})), React.createElement("g", {
  transform: "translate(-339 -2130)"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("use", {
  fill: "#7d8998",
  xlinkHref: "#wqcub"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#7ed327",
  xlinkHref: "#wqcuc"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#7ed327",
  xlinkHref: "#wqcud"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#7ed327",
  xlinkHref: "#wqcue"
})))));

var SvgAboutCar = function SvgAboutCar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 72,
    height: 52,
    viewBox: "0 0 72 52",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAboutCar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/aboutCar.846a95cd.svg";
export { ForwardRef as ReactComponent };